import { render, staticRenderFns } from "./1.vue?vue&type=template&id=fec13748&scoped=true"
var script = {}
import style0 from "./1.vue?vue&type=style&index=0&id=fec13748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec13748",
  null
  
)

export default component.exports